import styled from "styled-components";

const StyledVendorPage = styled.div`
  max-width: 100%;
  padding: 3% 7%;
`;

export default StyledVendorPage;
